export class ModuleQuestionBankReorderModel {
    id: string;
    zOrder: string;
}
